enum Categories {
  socialMedia = 'SOCIAL_MEDIA',
  contentCreation = 'CONTENT_CREATION',
  vote = 'VOTE',
  bounty = 'BOUNTY',
  airdrop = 'AIRDROP',
  msqTasks = 'MSQ_TASKS',
  learn2earn = 'LEARN2EARN',
}

export const icons = {
  [Categories.socialMedia]: '/store/wall/icons/social.png',
  [Categories.contentCreation]: '/store/wall/icons/content_creation.png',
  [Categories.vote]: '/store/wall/icons/vote.png',
  [Categories.bounty]: '/store/wall/icons/bounties.png',
  [Categories.airdrop]: '/store/wall/icons/airdrop.png',
  [Categories.msqTasks]: '/store/wall/icons/magic_store_tasks.png',
  [Categories.learn2earn]: '/store/wall/icons/learn2earn.png',
  default: '/store/wall/icons/content_creation.png',
};
